export default __webpack_public_path__ + "images/face_labeled-JT061.png";